/* Jewellery store enhancements — self-contained, never touches Shrine's external main.js internals. */
(function () {
  'use strict';

  /* ---------- Header: sticky wrapper, height var, drawer/search ---------- */
  function initHeader() {
    var h = document.querySelector('[data-jw-header]');
    if (!h || h.dataset.jwReady) return;
    h.dataset.jwReady = '1';
    var sec = h.closest('.shopify-section');
    if (sec && h.classList.contains('jw-header--sticky')) sec.classList.add('jw-sticky-sec');
    var setH = function () { document.documentElement.style.setProperty('--header-height', h.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);
    var drawer = h.querySelector('[data-jw-drawer]');
    var search = h.querySelector('[data-jw-search]');
    h.querySelectorAll('[data-jw-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (drawer) drawer.removeAttribute('open'); }); });
    if (drawer) drawer.addEventListener('toggle', function () { document.documentElement.classList.toggle('jw-lock', drawer.open); if (drawer.open && search) search.removeAttribute('open'); });
    if (search) search.addEventListener('toggle', function () { if (search.open) { var i = search.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 30); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (drawer) drawer.removeAttribute('open'); if (search) search.removeAttribute('open'); } });
    document.addEventListener('click', function (e) { if (search && search.open && !search.contains(e.target)) search.removeAttribute('open'); });
  }

  /* ---------- Cart icon: open Shrine's drawer if nothing else handled the click ---------- */
  function initCartIcon() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#cart-icon-bubble');
      if (!a || e.defaultPrevented) return;
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); try { d.open(a); } catch (err) { window.location.href = a.getAttribute('href'); } }
    });
  }

  /* ---------- Rails / carousels ---------- */
  function initRail(r) {
    var t = r.querySelector('.jw-rail__track');
    if (!t || r.dataset.jwReady) return;
    r.dataset.jwReady = '1';
    var loop = r.hasAttribute('data-loop');
    var step = function () { var it = t.querySelector('.jw-rail__item'); if (!it) return t.clientWidth; var gap = parseFloat(getComputedStyle(t).columnGap || getComputedStyle(t).gap) || 0; return it.getBoundingClientRect().width + gap; };
    var max = function () { return t.scrollWidth - t.clientWidth - 2; };
    var go = function (dir) {
      var s = step();
      if (dir > 0 && t.scrollLeft >= max()) { if (loop) t.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && t.scrollLeft <= 2) { if (loop) t.scrollTo({ left: t.scrollWidth, behavior: 'smooth' }); return; }
      t.scrollBy({ left: dir * s, behavior: 'smooth' });
    };
    var p = r.querySelector('[data-jw-prev]'), n = r.querySelector('[data-jw-next]');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
    var upd = function () {
      var scrollable = t.scrollWidth > t.clientWidth + 4;
      r.classList.toggle('jw-rail--static', !scrollable);
      if (!loop) { if (p) p.disabled = t.scrollLeft <= 2; if (n) n.disabled = t.scrollLeft >= max(); }
    };
    t.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  /* ---------- Before / after ---------- */
  function initBA(s) {
    var r = s.querySelector('.jw-ba__range');
    if (!r) return;
    var set = function () { s.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set); set();
    /* drag anywhere on the image (iOS only moves a range input from its thumb) */
    var dragging = false;
    var fromX = function (x) { var b = s.getBoundingClientRect(); var v = Math.max(0, Math.min(100, ((x - b.left) / b.width) * 100)); r.value = Math.round(v); set(); };
    s.addEventListener('pointerdown', function (e) { dragging = true; fromX(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (dragging) fromX(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });
    s.addEventListener('touchmove', function (e) { if (e.touches[0]) fromX(e.touches[0].clientX); }, { passive: true });
  }

  /* ---------- Scroll to buy box ---------- */
  function initToBuy() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-jw-tobuy]');
      if (!b) return;
      var target = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product');
      if (target) { e.preventDefault(); var y = target.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0) - 12; window.scrollTo({ top: y, behavior: 'smooth' }); }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-jw-rail]').forEach(initRail);
    (root || document).querySelectorAll('[data-jw-ba]').forEach(initBA);
  }
  document.addEventListener('DOMContentLoaded', function () { initHeader(); initCartIcon(); initToBuy(); init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector && e.target.querySelector('[data-jw-header]')) initHeader(); });
})();
/* ---------- Motion sections v3 ---------- */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cycler(root, slideSel, dotSel, ms, onShow) {
    var slides = root.querySelectorAll(slideSel), dots = root.querySelectorAll(dotSel), i = 0, t;
    if (slides.length < 2) return;
    var show = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (onShow) onShow(i);
    };
    var play = function () { clearInterval(t); if (!reduce) t = setInterval(function () { show(i + 1); }, ms); };
    dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.i); play(); }); });
    root.style.setProperty('--cyc', ms + 'ms');
    show(0); play();
  }
  function initAll(scope) {
    scope.querySelectorAll('[data-jw-slideshow]').forEach(function (r) { if (r.dataset.ok) return; r.dataset.ok = 1; cycler(r, '.jw-ss__slide', '.jw-ss__bar', (+r.dataset.interval || 6) * 1000); });
    scope.querySelectorAll('[data-jw-spotlight]').forEach(function (r) { if (r.dataset.ok) return; r.dataset.ok = 1; cycler(r, '.jw-spot__slide', '.jw-spot__dot', (+r.dataset.interval || 5) * 1000); });
    scope.querySelectorAll('[data-jw-quotes]').forEach(function (r) { if (r.dataset.ok) return; r.dataset.ok = 1; cycler(r, '.jw-qf__q', '.jw-qf__dots button', (+r.dataset.interval || 5) * 1000); });
    scope.querySelectorAll('[data-jw-fan]').forEach(function (r) {
      if (r.dataset.ok) return; r.dataset.ok = 1;
      var cards = [].slice.call(r.querySelectorAll('.jw-fan__card')), names = r.querySelectorAll('.jw-fan__names li'), n = cards.length, top = 0;
      var lay = function () { cards.forEach(function (c, k) { c.dataset.pos = (k - top + n) % n; }); names.forEach(function (li, k) { li.classList.toggle('is-on', k === top); }); };
      lay(); if (!reduce && n > 1) setInterval(function () { top = (top + 1) % n; lay(); }, (+r.dataset.interval || 3) * 1000);
    });
    scope.querySelectorAll('[data-jw-sticky]').forEach(function (r) {
      if (r.dataset.ok) return; r.dataset.ok = 1;
      var steps = r.querySelectorAll('.jw-ss2__step'), arts = r.querySelectorAll('.jw-ss2__art');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var i = +e.target.dataset.i; steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); arts.forEach(function (a, k) { a.classList.toggle('is-on', k === i); }); } }); }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
    scope.querySelectorAll('[data-jw-catlist]').forEach(function (r) {
      if (r.dataset.ok) return; r.dataset.ok = 1;
      r.querySelectorAll('.jw-cl__item a').forEach(function (a) {
        a.addEventListener('mousemove', function (e) { var b = a.getBoundingClientRect(); a.style.setProperty('--mx', (e.clientX - b.left) + 'px'); });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
